import React, { useEffect } from "react";

import "./Home.scss";
import Button from "../Button/Button";
import Shares from "../Shares/Shares";
import Header from "../Header/Header";
import { virtualPageView } from "../Analytics/Analytics";

function Home(props) {
  useEffect(() => {
    virtualPageView(window.location.hostname + window.location.pathname + "start", "Start");
  }, []);
  
  return (
    <>
    
      <Header setPageSection={props.setPageSection} class="home" />

      <div
        className={`home-container ${props.oneTimeDisplay ? "one-time" : ""}`}
      >
        <h1>שם המשחק</h1>
        {props.oneTimeDisplay ? (
          <>
            <h2>אנחנו שמחים שחזרת, אבל אפשר להשתתף רק פעם אחת</h2>
            <Shares label="Revisit User" location="Revisit Page" />
          </>
        ) : (
          <>
            <p className="desc">
              מ-FIFA ועד מיינקראפט, מה-Sims ועד מורטל קומבט: הגיע הזמן להכריע
              אחת ולתמיד - מהו משחק הווידאו הטוב ביותר בכל הזמנים? 
              ynet ומוסף "7 לילות" של "ידיעות אחרונות"
            </p>
            <p className="sub-desc">
              מזמינים אתכם לקחת חלק במצעד הגיימינג הגדול
            </p>
            <Button
              text="התחילו להצביע"
              class="start-vote"
              onClickHandle={() => props.setPageSection("votes")}
            />
            <p className="bottom">
              התוצאות ייחשפו בפרויקט מיוחד של ynet ומוסף "7 לילות"
            </p>
          </>
        )}
        <div className="overlay">
          {/* <div className="e1"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e2"></div>
          <div className="e3"></div>
          <div className="e4"></div>
          <div className="e5"></div>
          <div className="e6"></div>
          <div className="e7"></div>
          <div className="e8"></div>
          <div className="e9 desktop"></div>
          <div className="e10 desktop"></div>
          <div className="e11 desktop"></div>
          <div className="e12 desktop"></div> */}
        </div>
      </div>
    </>
  );
}

export default Home;
